import { Outlet, NavLink , Link} from "react-router-dom"
import Breadcrumbs from "../components/Breadcrumbs"

export default function RootLayout() {
  return (
    <div className=" root-layout">
      <header>
        <nav>
        {/* <h1 className="logo">1sTest</h1> */}
    <Link to='/' className="logo-link"> <h1 className="logo">1sTest</h1> </Link>
    <NavLink to="careers">ابحث عن مدرسة </NavLink>
          {/* <NavLink to="about">عنا</NavLink> */}
          <NavLink to="help">ارشادات</NavLink>
          {/* <NavLink to="quiz">اختبار</NavLink> */}
          {/* <NavLink to="learn">أدرس </NavLink> */}
          <NavLink to="start">ابدأ </NavLink>
          {/* <NavLink to="/">الرئيسية</NavLink> */}


        </nav>
        <Breadcrumbs className="bread" />
      </header>
      <main className="wrapper">
        <Outlet />
      </main>
      <footer className="footer" dir="rtl">
        <div className="container-footer">
          {/* <h1 className="logo">1sTest</h1> */}
          <Link to='/' className="logo-link"> <h1 className="logo">1sTest</h1> </Link><br></br>


          <div class="copyright" dir="ltr"> © 2023 <span className="text-color-primary"> 1sTest </span>. حقوق النشر محفوظة  </div>

          <nav className="privacy-policy">
            <NavLink to="privacy" className='link'>الشروط و الأحكام </NavLink>
          <NavLink to="about" className='link'>عنا</NavLink>
            

          </nav>
        </div>
      </footer>
    </div>
  )
}
